/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {Box, Text} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React from 'react'
import {useIntl} from 'react-intl'
import {useItemVariant} from '.'
import {productUrlBuilder} from '../../utils/url'
import Link from '../link'

/**
 * In the context of a cart product item variant, this components simply renders
 * the item's name using the master product name (STOKKE customiztion).
 * In case the cart item field `productName`. We use this field
 * rather than variant `name` field as the variant detail may not yet be
 * available upon rendering.
 */
const ItemName = ({link = true, ...props}) => {
    const intl = useIntl()
    const variant = useItemVariant()
    const productId = variant.master?.masterId || variant.productId || variant.id
    const Component = link ? Link : Text
    return (
        <Box width="full">
            <Component
                /* disable text style from theme by using undefined size */
                size="none"
                textStyle="Semi Bold Medium"
                textDecoration="none"
                {...props}
                {...(link && {
                    to: productUrlBuilder(
                        {id: productId},
                        intl.locale,
                        variant.slugUrl || variant.c_slugUrl
                    )
                })}
            >
                {variant.master?.name || variant.productName || variant.name}
            </Component>
        </Box>
    )
}

ItemName.propTypes = {
    link: PropTypes.bool
}

export default ItemName
